import { EventBus } from "../../../eventbus";
import { baseUrl } from "../../../config";

export default {
  data() {
    return {
      id: this.$options.name,
      optionsData: {},
    };
  },
  created() {
    EventBus.$on(`${this.$options.name}-show`, (data) => {
      //show this overlay
      EventBus.$emit("openOverlayPage", data);

      if (data.optionsData) {
        this.optionsData = data.optionsData;
      } else {
        this.optionsData = {};
      }
    });

    EventBus.$on(`${this.$options.name}-delete`, (data) => {
      if (data.id) {
        this.deleteSpace(data.id);
      }
    });
  },
  methods: {
    deleteSpace(id) {
      const formData = new FormData();

      formData.append("folder", id);

      this.$axios
        .post(baseUrl + "/folderdelete", formData)
        .then((r) => {
          //close overlay
          EventBus.$emit("closeOverlayPage", { id: this.$options.name });

          //remove space from list
          EventBus.$emit("spaces-holder-update-spaces", {});
        })
        .catch((r) => {
          //this.errors.push("Something went wrong. Try again later.");
        });
    },
  },
};
